import { create } from "zustand";
import { validTimezone } from "@/lib/timezone";

export const useCompanyTimezoneStore = create<{
  companyId: string | null;
  timeZone: string;
  set: (companyId: string, timeZone: string) => void;
  reset: () => void;
}>((set) => ({
  companyId: null,
  timeZone: "UTC",
  set: (companyId, timeZone) =>
    set({ companyId, timeZone: validTimezone(timeZone) || "UTC" }),
  reset: () => set({ companyId: null, timeZone: "UTC" }),
}));
